import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { CollapsibleTable, InstitutionsContext } from "@ngt/opms";
import { FC, useContext, useEffect, useState } from "react";
import { ImageUploadUpdaterContext } from "../../contexts/ImageUploadUpdaterContext";
import MriImageUploadsContext from "../../hooks/context/MriImageUploadsContext";
import useRunDicomSignalR from "../../hooks/signalR/useRunDicomSignalR";
import useImageUploadColumns from "./useImageUploadColumns";

interface IImageUploadTableProps {
    canAdministerOpms: boolean;
    isSiteUSer: boolean;
    isCentralReviewer: boolean;
}

const pageSizeOptions = [100, 150, 200, 250, 300]

// const NotUploadCheck = (upload: MriImageUpload) => {
//     return (
//         (upload.mammogramPerformed === true &&
//         !upload.cemDocument?.file) ||
//         (
//         !upload.imageDocument?.file)
//     );
// }
// const NotVerifiedCheck = (upload: MriImageUpload) => {
//     return (
//         (upload.cemDocument?.isDeIdentified === true &&
//         (upload.cemDocument?.isVerified === undefined || 
//         upload.cemDocument?.isVerified === null)) 
//         || 
//         (upload.imageDocument?.isDeIdentified === true &&
//         (upload.imageDocument?.isVerified === undefined || 
//         upload.imageDocument?.isVerified === null))
//     );
// }
// const DeidentifiedFailedCheck = (upload: MriImageUpload) => {
//     return (
//         upload.cemDocument?.deIdentifiedFailed || 
//         upload.imageDocument?.deIdentifiedFailed
//     );
// }

const ImageUploadTable: FC<IImageUploadTableProps> = ({
    canAdministerOpms,
    isSiteUSer,
    isCentralReviewer
}) => {
    const oldTheme = useTheme();

    const theme = createTheme({
        ...oldTheme,
        components: {
            ...oldTheme.components,
            MuiDataGrid: {
                ...oldTheme.components?.MuiDataGrid,
                styleOverrides: {
                    ...oldTheme.components?.MuiDataGrid?.styleOverrides,
                    row: {
                        "&:nth-of-type(even)": {
                            "&:hover": {
                                cursor: "default !important",
                                backgroundColor: oldTheme.palette.mode === 'dark' ? 
                                    `#292929 !important` :
                                    `#eee !important`,
                            },
                        },
                        "&:hover": {
                            cursor: "default !important",
                            backgroundColor: oldTheme.palette.mode === 'dark' ? 
                                `#212121 !important` :
                                `transparent !important`,
                        },
                    }
                },
            },
        },
    });

    const [tableCount, setTableCount] = useState(1);

    const { data: contextImageUploads, loading: contextImageUploadsLoading } = useContext(MriImageUploadsContext);

    // const filteredImageUploads = useMemo(() => {
    //     return contextImageUploads?.filter(upload => {
    //         if (!selectedImagesNotUploaded && !selectedImagesNotVerified && !selectedImagesDeidentifiedFailed) {
    //             return true;
    //         }
    //         // combinations
    //         if (selectedImagesNotUploaded && selectedImagesNotVerified && selectedImagesDeidentifiedFailed) {
    //             return NotUploadCheck(upload) && NotVerifiedCheck(upload) && DeidentifiedFailedCheck(upload);
    //         }
    //         if (selectedImagesNotUploaded && selectedImagesNotVerified && !selectedImagesDeidentifiedFailed) {
    //             return NotUploadCheck(upload) && NotVerifiedCheck(upload);
    //         }
    //         if (selectedImagesNotUploaded && !selectedImagesNotVerified && selectedImagesDeidentifiedFailed) {
    //             return NotUploadCheck(upload) && DeidentifiedFailedCheck(upload);
    //         }
    //         if (!selectedImagesNotUploaded && selectedImagesNotVerified && selectedImagesDeidentifiedFailed) {
    //             return NotVerifiedCheck(upload) && DeidentifiedFailedCheck(upload);
    //         }
    //         // single checks
    //         if (selectedImagesNotUploaded && NotUploadCheck(upload)) {
    //             return true;
    //         }
    //         if (selectedImagesNotVerified && NotVerifiedCheck(upload)) {
    //             return true;
    //         }
    //         if (selectedImagesDeidentifiedFailed && DeidentifiedFailedCheck(upload)) {
    //             return true;
    //         }
    //         return false;
    //     });
    // }, [contextImageUploads, selectedImagesNotUploaded, selectedImagesNotVerified, selectedImagesDeidentifiedFailed]);


    const { data: institutions } = useContext(InstitutionsContext);

    const columns = useImageUploadColumns(
        institutions ?? null, 
        canAdministerOpms,
        isSiteUSer,
        isCentralReviewer
    );

    const imageUploadUpdater = useContext(ImageUploadUpdaterContext)
    // time needed because otherwise if the value is the same, the table will not re-render
    const { dicomId, dateTime } = useRunDicomSignalR();

    useEffect(() => {
        if (dicomId) {
            imageUploadUpdater.notify(dicomId);
        }
    }, [dicomId, dateTime]);

    useEffect(() => {
        setTableCount(x => x + 1);
    }, [columns, contextImageUploads]);
    
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);

    return (
        <>
            <ThemeProvider theme={theme}>
                <CollapsibleTable
                    key={tableCount}
                    rows={contextImageUploads ?? []}
                    loading={contextImageUploadsLoading}
                    columns={columns as any}
                    //options={tableOptions}
                    pageSizeOptions={pageSizeOptions}
                    initialState={{ 
                        pagination: { paginationModel: { pageSize: 100 }},
                    }}
                    title={"Participant Image Uploads"}
                    pluralizeTitle={false}
                    entityName={"Participant"}
                    disabledTableText={"There are no participants eligible for uploads."}
                    startCollapsed={false}
                    paginationModel={{ page: page, pageSize: pageSize }}
                    onPaginationModelChange={(paginationModel) => {
                        setPage(paginationModel.page);
                        setPageSize(paginationModel.pageSize);
                    }}
                />
            </ThemeProvider>
        </>
        
    );
}

export default ImageUploadTable;